export const CONTROL_PANEL_WIDTH = 384; // 24rem in pixels
export const MOBILE_BREAKPOINT = 769; // px
